export const CONSENT_MODE_KEY = 'consentMode';
